module.exports = __webpack_public_path__ + "static/media/tbs.5d433530.svg";